// extracted by css-extract-rspack-plugin
export default {"cls1":"FullScreenPremiumModal-cls1_3K3","cls2":"FullScreenPremiumModal-cls2_G0p FullScreenPremiumModal-cls1_3K3"};